module.exports = {
    parallel: require('./lib/parallel'),
    series: require('./lib/series'),
    eachSeries: require('./lib/each-series'),
    eachParallel: require('./lib/each-parallel')
};
